import { PerspectiveCamera } from '@react-three/drei';
import { Canvas } from '@react-three/fiber';
import { PCFShadowMap, LinearSRGBColorSpace, SRGBColorSpace, ACESFilmicToneMapping, LinearToneMapping } from 'three';
import { I as ImageSizes, S as Sizes } from './common-DBpCdW70.esm.js';
import { A as Assets } from './index-CAxCDj_E.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import 'clsx';
import 'react';

const Scene = ({
  children,
  assetName,
  size = Sizes.MEDIUM
}) => {
  const castShadows = [Assets.LOCK, Assets.MULTI_CURRENCY, Assets.MAGNIFYING_GLASS, Assets.INTEREST].includes(assetName);
  /**
   * @deprecated this is a temporary variable until we migrate all models to v2 (DS-6879)
   */
  const isV2 = [Assets.INTEREST].includes(assetName);
  return /*#__PURE__*/jsxs(Canvas, {
    onCreated: ({
      gl
    }) => {
      gl.setClearColor(0x000000, 0);
      gl.setSize(ImageSizes[size], ImageSizes[size]);
      gl.clearDepth();
      // eslint-disable-next-line functional/immutable-data, no-param-reassign
      gl.useLegacyLights = !isV2;
    },
    gl: {
      alpha: true,
      antialias: !isV2,
      pixelRatio: window.devicePixelRatio * 1,
      toneMapping: isV2 ? ACESFilmicToneMapping : LinearToneMapping,
      outputColorSpace: isV2 ? LinearSRGBColorSpace : SRGBColorSpace,
      toneMappingExposure: 1.1
    },
    shadows: {
      type: PCFShadowMap,
      enabled: castShadows
    },
    children: [/*#__PURE__*/jsx(PerspectiveCamera, {
      makeDefault: true,
      far: 1000000000000,
      near: 0.1,
      fov: 10.29,
      aspect: window.innerWidth / window.innerHeight,
      position: [0, 0, 100]
    }), children]
  });
};

export { Scene as default };
//# sourceMappingURL=Scene-BbP_hcsH.esm.js.map
